import { render, staticRenderFns } from "./tabulacao-form.vue?vue&type=template&id=25406b34&scoped=true"
import script from "./tabulacao-form.vue?vue&type=script&lang=js"
export * from "./tabulacao-form.vue?vue&type=script&lang=js"
import style0 from "./tabulacao-form.vue?vue&type=style&index=0&id=25406b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25406b34",
  null
  
)

export default component.exports